import {LOGIN_TYPE_AD, LOGIN_TYPE_AUTH, LOGIN_TYPE_AUTH_WITH_GROUPS, LOGIN_TYPE_HASHED, LOGIN_TYPE_LDAP, LOGIN_TYPE_MANUAL} from "../../constants/user-login-constants";
import {getGlobalTranslator} from "@/services/utilities/ServiceError.ts";
import {TranslationKeys} from "@/contexts/TranslationKeys.ts";

export const isLdapLogin = (loginTypeId: number): boolean => {
    return loginTypeId === LOGIN_TYPE_LDAP;
};

export const isAuthLogin = (loginTypeId: number): boolean => {
    return loginTypeId === LOGIN_TYPE_AUTH;
}

export const isAuthWithGroupsLogin = (loginTypeId: number): boolean => {
    return loginTypeId === LOGIN_TYPE_AUTH_WITH_GROUPS;
}

export const getTranslationMessageForPasswordExpiring = (messageDetails: any): string => {
    const translator = getGlobalTranslator();
    if (messageDetails.sevenDaysToExpire) {
        return translator.byKey(TranslationKeys.sevenDaysToPasswordExpired);
    } else if (messageDetails.passwordExpired) {
        return translator.byKey(TranslationKeys.passwordHasExpired);
    } else if (messageDetails.oneDayToExpire) {
        return translator.byKey(TranslationKeys.oneDayToPasswordExpire);
    } else if (messageDetails.oneMonthToExpire) {
        return translator.byKey(TranslationKeys.lessThanOneMonthToExpire);
    } else if (messageDetails.failsRequirementCheck) {
        return translator.byKey(TranslationKeys.notMeetingRequirements);
    }
    return translator.byKey(TranslationKeys.genericPasswordWarning);
};

export const getLoginTypeLookup = () : any[] => {
    const translator = getGlobalTranslator();
    return [
        { value: LOGIN_TYPE_MANUAL, label: translator.byKey(TranslationKeys.standard) },
        { value: LOGIN_TYPE_LDAP, label: translator.byKey(TranslationKeys.ldap) },
        { value: LOGIN_TYPE_AD, label: translator.byKey(TranslationKeys.activeDirectory)},
        { value: LOGIN_TYPE_HASHED, label: translator.byKey(TranslationKeys.manual)},
        { value: LOGIN_TYPE_AUTH, label: translator.byKey(TranslationKeys.identityProvider) },
        { value: LOGIN_TYPE_AUTH_WITH_GROUPS, label: translator.byKey(TranslationKeys.identityProviderWithGroups) }
    ]
}
